"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.DEFAULT_NESTED_CARDS_PER_ROW = exports.DEFAULT_CARDS_PER_ROW = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _QuickLink = _interopRequireDefault(require("./QuickLink"));

var _ShowMoreButton = _interopRequireDefault(require("./ShowMoreButton"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _zod = require("zod");

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("@insided/destination/shared/constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'quick_links';
exports.widgetName = widgetName;
var DEFAULT_CARDS_PER_ROW = 3;
exports.DEFAULT_CARDS_PER_ROW = DEFAULT_CARDS_PER_ROW;
var DEFAULT_NESTED_CARDS_PER_ROW = 2;
exports.DEFAULT_NESTED_CARDS_PER_ROW = DEFAULT_NESTED_CARDS_PER_ROW;
var cssAnchorName = 'widget-quick_links';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string().optional(),
  selectedMobileLayout: _zod.z.union([_zod.z.literal('verticallyStacked'), _zod.z.literal('horizontallyScrollable')]).optional(),
  selectedCardsPerRow: _zod.z.union([_zod.z.literal(2), _zod.z.literal(3), _zod.z.literal(4), _zod.z.literal(5), _zod.z.literal(6)]).optional(),
  quickLinks: _zod.z.array(_zod.z.object({
    id: _zod.z.string(),
    title: _zod.z.string(),
    url: _zod.z.string(),
    description: _zod.z.string(),
    openNewTab: _zod.z.boolean(),
    iconSrc: _zod.z.string().or(_zod.z.null()),
    imageSrc: _zod.z.string().or(_zod.z.null())
  })).default([])
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;
var MAXIMUM_ROW_COUNT = 2;
var LEGACY_ITEMS_PER_CONTAINER = 6;

function getItemsPerContainer(selectedCardsPerRow) {
  if (selectedCardsPerRow === 2) return LEGACY_ITEMS_PER_CONTAINER;
  return selectedCardsPerRow * MAXIMUM_ROW_COUNT;
}

var QuickLinksContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(QuickLinksContainer, _Component);

  var _super = _createSuper(QuickLinksContainer);

  function QuickLinksContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, QuickLinksContainer);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showAll: _this.props.showAll
    });
    _this.showMoreHandler = _this.showMoreHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.getSelectedCardsPerRow = _this.getSelectedCardsPerRow.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(QuickLinksContainer, [{
    key: "showMoreHandler",
    value: function showMoreHandler() {
      this.setState(function (currentState) {
        return {
          showAll: !currentState.showAll
        };
      });
    }
  }, {
    key: "getSelectedCardsPerRow",
    value: function getSelectedCardsPerRow() {
      var _config$quickLinks;

      var _this$props = this.props,
          config = _this$props.config,
          isNested = _this$props.isNested;
      if (config.selectedCardsPerRow) return config.selectedCardsPerRow;
      var hasFourQuickLinks = ((_config$quickLinks = config.quickLinks) === null || _config$quickLinks === void 0 ? void 0 : _config$quickLinks.length) === 4;
      return (isNested !== null && isNested !== void 0 ? isNested : hasFourQuickLinks) ? DEFAULT_NESTED_CARDS_PER_ROW : DEFAULT_CARDS_PER_ROW;
    }
  }, {
    key: "render",
    value: function render() {
      var _config$selectedMobil,
          _this2 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          config = _this$props2.config;
      var showAll = this.state.showAll;
      var classNames = 'full-width Template-brand-featured qa-quicklinks-container quicklinks-wrapper custom-quicklink';

      if (!data.length) {
        return null;
      }

      var selectedCardsPerRow = this.getSelectedCardsPerRow();
      var itemsPerContainer = getItemsPerContainer(Number(selectedCardsPerRow));
      var selectedMobileLayout = (_config$selectedMobil = config.selectedMobileLayout) !== null && _config$selectedMobil !== void 0 ? _config$selectedMobil : 'horizontallyScrollable';
      var fillSpace = data.length >= 5 && data.length % 3 === 2;
      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: widgetName,
        config: config,
        className: classNames
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('content--centered quicklink__container', _constants.MOBILE_VIEW_LAYOUTS_SNAKE_CASE[selectedMobileLayout], {
          'fill-space': fillSpace
        })
      }, data.map(function (item, idx) {
        return (0, _preact.h)(_QuickLink.default, {
          key: "quicklink-".concat(idx),
          item: item,
          idx: idx,
          hasWidgetTitle: Boolean(config.title),
          hasWidgetSubtitle: Boolean(config.subtitle),
          isVisibleDesktop: Boolean(showAll) || idx < itemsPerContainer,
          selectedCardsPerRow: selectedCardsPerRow
        });
      })), data.length > itemsPerContainer && (0, _preact.h)(_ShowMoreButton.default, {
        quickLinksLength: data.length,
        itemsPerContainer: itemsPerContainer,
        showMore: function showMore() {
          return _this2.showMoreHandler();
        },
        showAll: showAll
      }));
    }
  }]);
  return QuickLinksContainer;
}(_preact.Component);

exports.default = QuickLinksContainer;